import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { getAmountAvailable, getNextAvailableDate, getOutOfStock } from 'Src/js/helpers/TireQuantityHelper';
import { IListableProductJson } from 'JS/types/Product';
import { ILocalStoreJson } from 'JS/types/LocalStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TireStockStatus',
  props: {
    product: null,
    store: null
  },
  setup(__props: any) {

const props = __props as {
	product: IListableProductJson;
	store: ILocalStoreJson;
}



const qtyDesired = 4;

const outOfStock = computed(() => getOutOfStock(props.product));
const totalAvailable = computed(() => getAmountAvailable(props.product));
const lowStock = computed(() => totalAvailable.value < qtyDesired);
const fullQtyNextAvailableDate = computed(() => getNextAvailableDate(props.product, qtyDesired));
const lowQtyNextAvailableDate = computed(() => getNextAvailableDate(props.product, totalAvailable.value));

return { __sfc: true,props, qtyDesired, outOfStock, totalAvailable, lowStock, fullQtyNextAvailableDate, lowQtyNextAvailableDate }
}

})